"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodeList = void 0;
var icons_1 = require("../icons");
var Icons = { Docs: icons_1.DocsIcon, Orb: icons_1.OrbIcon };
var KeyCodeList;
(function (KeyCodeList) {
    KeyCodeList[KeyCodeList["SPACE"] = 32] = "SPACE";
    KeyCodeList[KeyCodeList["DOWN_ARROW"] = 40] = "DOWN_ARROW";
    KeyCodeList[KeyCodeList["UP_ARROW"] = 38] = "UP_ARROW";
    KeyCodeList[KeyCodeList["TAB"] = 9] = "TAB";
    KeyCodeList[KeyCodeList["ESCAPE"] = 27] = "ESCAPE";
})(KeyCodeList = exports.KeyCodeList || (exports.KeyCodeList = {}));
//# sourceMappingURL=utils.js.map